module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='  <div id="queryManagementContent" class="innerContent">\n  </div>\n\n  <div class="queryManagementBottomActions">\n    <button id="deleteSlowQueryHistory" class="button-danger query-button">Delete History</button>\n  </div>\n';
}
return __p;
};
